const m = require('minthril');
const { component } = require('../../component');

const outcomeLabels = {
  matched: 'Matches Chromium',
  mismatch: 'Content mismatch — using Chromium',
  inconclusive: 'Source changed between renders — using Chromium',
  rejected: 'jsdom rejected — using Chromium',
  error: 'Chromium comparison failed'
};

const metricLabels = [
  ['jsdomAttempts', 'jsdom attempts'],
  ['jsdomRejected', 'Rejected attempts'],
  ['jsdomSkippedAfterCheck', 'jsdom attempts skipped'],
  ['jsdomFallbacks', 'Chromium fallbacks'],
  ['rendererComparisons', 'Chromium comparisons'],
  ['rendererComparisonMatches', 'Matching comparisons'],
  ['rendererComparisonMismatches', 'Content mismatches'],
  ['rendererComparisonInconclusive', 'Inconclusive comparisons'],
  ['rendererComparisonErrors', 'Failed comparisons']
];

const RendererHealth = component(() => {
  return {
    view: ({ attrs: { comparison, metrics, enabled, periodHours = 168 } }) => {
      if (!enabled && !comparison && !metrics?.jsdomAttempts) return null;
      return m('section.renderer-health', [
        m('h3', 'Renderer checks'),
        comparison ? [
          m('p', outcomeLabels[comparison.outcome] || 'No completed comparison'),
          m('p.muted', `Last check: ${new Date(comparison.checkedAt).toLocaleString()}`),
          comparison.differences?.length > 0 && m('p',
            `Differences: ${comparison.differences.map(name => name.replace(/_/g, ' ')).join(', ')}`),
          Number.isFinite(comparison.jsdomTextLength) && m('p.muted',
            `Text length: jsdom ${comparison.jsdomTextLength}, Chromium ${comparison.chromiumTextLength} characters.`),
          m('p.muted', `Next comparison: next required render after ${new Date(comparison.nextCheckAt).toLocaleString()}`)
        ] : m('p.muted', 'The first jsdom candidate will be compared with Chromium.'),
        metrics && [
          m('p.muted', `Measurements over the last ${periodHours / 24} days`),
          m('dl', metricLabels.map(([name, label]) => [
            m('dt', label), m('dd', Number(metrics[name] || 0).toLocaleString())
          ]))
        ],
        m('small.muted', 'Checks compare page content, metadata, links, headings, images, forms, and structured data. They do not verify browser layout or interactions.')
      ]);
    }
  };
});

module.exports = { RendererHealth };
